import { UserGroupEnum } from 'videoservice-openapi-react';
import { EColorsNames } from 'shared/types';
import { Role2BadgeMap } from '../../model/roles/roles';

export const useRoleColor = (role?: UserGroupEnum) => {
  return role ? Role2BadgeMap[role] : EColorsNames.Blue;
};
